<template>
  <el-container>
    <el-aside width="25%">
      <el-container>
        <el-header height="36px">
          <el-autocomplete
            v-model="PurchaserNameQQ"
            value-key="PurchaserName"
            :fetch-suggestions="querySearch"
            placeholder="搜索客户"
            @select="handleSeletedPurchaser($event)"
            style="width: 100%"
          ></el-autocomplete>
        </el-header>
        <el-main>
          <el-input
            id="analyse-content"
            ref="analyseContent"
            type="textarea"
            resize="none"
            v-model="analyseContent"
            :placeholder="'请输入报单的内容，示例：\n王丹 15285037206\n福建省 泉州市 永春县 蓬壶镇美山村福邸美景615-11号\n张三\nHH1234 1\nHH1234 黑色*1 白色*2\nHH1234 黑色 39*1 40*2\n'"
          ></el-input>
        </el-main>
      </el-container>
    </el-aside>
    <el-aside width="70px">
      <div>
        <el-button type="primary" @click="analyse" :disabled="loading" style="margin-top: 10px">解析</el-button>
      </div>
      <!-- <div>
                <el-button type="primary"  @click="handProxyShow(message)"  style="margin-top:50px;">设为代发</el-button>
            </div> -->
      <div>
        <el-button type="primary" @click="save" :disabled="loading" style="margin-top: 50px">提交</el-button>
      </div>
      <div>
        <el-button type="danger" @click="clear" style="margin-top: 50px">清除</el-button>
      </div>
      <div>
        <el-button type="primary" @click="handleImport" style="margin-top: 50px">导入</el-button>
      </div>
      <div style="position: absolute; bottom: 10px">
        <el-button type="primary" @click="config" style="margin-top: 10px">配置</el-button>
      </div>
    </el-aside>
    <el-main style="border-left: 0">
      <el-container style="border: 0">
        <el-main>
          <stall-trade-table
            ref="gridTable"
            :anyalyse-load.sync="loading"
            :add-enable.sync="addEnable"
            :analyseConfig="analyseConfig"
            @handleSave="clear"
          />
        </el-main>
        <el-footer height="40px">
          <el-switch
            v-if="$store.state.routes.systemSetting.WmsEnabled"
            style="float: right; margin: 10px"
            v-model="$store.state.routes.systemSetting.CheckStock"
            active-text="看缺货"
            @change="$store.dispatch('routes/changeSettingItem', { CheckStock: $store.state.routes.systemSetting.CheckStock })"
          />
        </el-footer>
      </el-container>
    </el-main>
    <stall-config ref="analyseConfig" :field.sync="configField" :value.sync="analyseConfig" :level="0" source="analyse" :dialog="true">
    </stall-config>
    <trade-import ref="TradeImport" />

    <div class="page-dialog">
      <el-dialog
        :visible="proxyForm.visible"
        :title="proxyForm.title"
        @close="proxyForm.visible = false"
        :close-on-click-modal="false"
        width="800px"
      >
        <el-form label-suffix="：" label-width="100px">
          <el-form-item label="报单内容">
            <span>{{ proxyForm.originContent }}</span>
          </el-form-item>
        </el-form>
        <el-descriptions :column="2" border>
          <el-descriptions-item span="2">
            <template slot="label">
              <i class="el-icon-user"></i>
              订单号
            </template>
            <el-input v-model="proxyForm.proxy.Tid" />
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              收件人
            </template>
            <el-input v-model="proxyForm.proxy.ReceiverName" />
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              手机号
            </template>
            <el-input v-model="proxyForm.proxy.ReceiverMobile" />
          </el-descriptions-item>
          <el-descriptions-item span="2">
            <template slot="label">
              <i class="el-icon-office-building"></i>
              地址
            </template>
            <el-input v-model="proxyForm.proxy.ReceiverProvince" style="max-width: 110px" />
            <el-input v-model="proxyForm.proxy.ReceiverCity" style="max-width: 110px" />
            <el-input v-model="proxyForm.proxy.ReceiverDistrict" style="max-width: 110px" />
            <el-input v-model="proxyForm.proxy.ReceiverAddress" style="max-width: calc(100% - 330px)" />
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-office-building"></i>
              商品
            </template>
            <el-input v-model="proxyForm.proxy.Content" type="textarea" />
          </el-descriptions-item>
        </el-descriptions>
        <div slot="footer" class="dialog-footer">
          <el-button @click="proxyForm.visible = false">取 消</el-button>
          <el-button type="primary" @click="handleProxySave">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-container>
</template>
<script>
import { submit } from '@/api/base'
import StallTradeTable from '@/views/stall/trade/components/StallTradeTable.vue'
import StallConfig from '@/views/stall/trade/components/StallConfig.vue'
import TradeImport from '@/views/stall/trade/components/Import.vue'

export default {
  name: 'newStallTradeAdd',
  components: {
    StallTradeTable,
    StallConfig,
    TradeImport,
  },
  beforeDestroy() {
    if (this.analyseContent != '') {
      this.$cookies.set('stall_copy_content', this.analyseContent)
    } else {
      this.$cookies.remove('stall_copy_content')
    }
  },
  data() {
    return {
      loading: false,
      analyseContent: '',
      configField: {},
      analyseConfig: {},
      addEnable: false,
      checkStock: false,
      PurchaserNameQQ: '',
      searchPurchases: [],
      proxyForm: {
        visible: false,
        title: '设置代发信息',
        id: '',
        proxy: {},
      },
    }
  },
  mounted() {
    var that = this
    that.$nextTick(() => {
      that.clear()
      let content = that.$cookies.get('stall_copy_content')
      if (content) {
        that.analyseContent = content //赋值之前内容
      }
      that.loadPurchases()
      that.$refs.analyseConfig.getConfig()
    })
  },
  methods: {
    // handleChildEvent(message) {
    //     this.proxyForm.visible = true;
    //   this.proxyForm.originContent = message.Content;
    //   this.proxyForm.id = message.Id;
    //   this.proxyForm.proxy = message.ProxyResult;
    // },
    handProxyShow(message) {
      this.proxyForm.visible = true
      this.proxyForm.originContent = message.Content
      this.proxyForm.id = message.Id
      this.proxyForm.proxy = message.ProxyResult
    },
    async handleProxySave() {
      await submit('/api/stall/proxy/save', {
        trade: {
          Proxy: this.proxyForm.proxy,
          MessageIDs: [this.proxyForm.id],
        },
        saveType: 0,
      })
      this.proxyForm = { visible: false, title: '设置代发信息', id: '', proxy: {} }
      this.loadMessages(this.currentSender)
      this.$message({ type: 'success', message: `操作成功!` })
    },
    //客户名称模糊搜索
    async querySearch(queryString, callback) {
      // 调用 callback 返回建议列表的数据
      var results = queryString
        ? this.searchPurchases.filter(x => {
            let queryStr = queryString.toLowerCase()
            if (typeof x.Name != 'undefined' && x.Name != '' && x.Name.toLowerCase().indexOf(queryStr) >= 0) {
              return true
            }
            if (typeof x.Nick != 'undefined' && x.Nick != '' && x.Nick.toLowerCase().indexOf(queryStr) >= 0) {
              return true
            }
            let config = x.Config
            if (typeof config != 'undefined') {
              if (typeof config.PinYin && config.PinYin != '' && config.PinYin.toLowerCase().indexOf(queryStr) >= 0) {
                return true
              }
              if (typeof config.PinYinFirst && config.PinYinFirst != '' && config.PinYinFirst.toLowerCase().indexOf(queryStr) >= 0) {
                return true
              }
            }
            return false
          })
        : this.searchPurchases
      callback(results)
    },
    async handleSeletedPurchaser(selectedRow) {
      let name = selectedRow.Name
      let content = this.analyseContent
      if (content == '') {
        this.analyseContent = name + '\n'
      } else {
        if (!(content.trim().endsWith('\n' + name) || content.trim().endsWith(name))) {
          this.analyseContent += '\n\n' + name + '\n'
        }
      }
      this.PurchaserNameQQ = ''
      this.$refs.analyseContent.focus()
    },
    async loadPurchases() {
      const { data } = await submit('/api/stall/getPurchaserList', {
        searchValue: '',
        ToPage: false,
      })
      data.forEach(d => {
        d.PurchaserName = d.Name + (d.QQ ? '(' + d.QQ + ')' : '')
      })
      this.searchPurchases = data
    },
    clear() {
      this.analyseContent = ''
      this.$refs.gridTable.init()
    },
    config() {
      this.$refs.analyseConfig.showDialog()
    },
    async analyse() {
      if (this.loading) {
        return
      }
      var that = this
      if (!this.analyseContent) {
        this.$baseMessage('报单内容不可为空', 'error')
        return
      }
      this.loading = true
      this.$refs.gridTable.init(null, that.analyseContent)
    },
    async save() {
      if (this.analyseContent == '') return
      this.$refs.gridTable.handleAddOrder()
    },
    handleImport() {
      const that = this
      that.$nextTick(() => {
        that.$refs.TradeImport.initDialog(
          '订单导入',
          '/api/stall/importTrade',
          '/static/Upload/订单导入模版-接单.xls',
          '订单导入模版-接单.xls'
        )
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-aside {
    .el-textarea {
      height: 100%;
    }

    .el-textarea__inner {
      height: 100%;
    }
  }

  .el-main {
    border-top: 0px !important;
    .stall-trade-table {
      height: 100%;
    }
  }
}
</style>
